/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.18/esri/copyright.txt for details.
*/
function o(o){return"heatmap"===o?import("./processors/HeatmapProcessor.js"):import("./processors/SymbolProcessor.js")}export{o as loadProcessorModule};
